export type NetworkErrorCode = 'errors.network.offline' | 'errors.network.unreachable';

/**
 * A transport failure has two very different causes for the user: their own
 * connection is down, or ours is. `navigator.onLine === false` is the only
 * reliable half of that signal — `true` merely means the browser has *a*
 * network, not that the API answered — so "you are offline" is claimed only
 * when the browser positively reports the link is down, and everything else
 * (the API blipping, DNS, a reset connection) gets the neutral unreachable copy.
 */
function networkCode(): NetworkErrorCode {
  return typeof navigator !== 'undefined' && navigator.onLine === false
    ? 'errors.network.offline'
    : 'errors.network.unreachable';
}

/** No HTTP response at all (fetch threw, offline, aborted). Client-minted id. */
export class NetworkError extends Error {
  readonly status = 0;
  readonly id: string;
  readonly code: NetworkErrorCode;

  constructor(opts: { cause?: unknown } = {}) {
    const code = networkCode();

    super(code);
    this.name = 'NetworkError';
    this.code = code;
    this.id = crypto.randomUUID();

    if (opts.cause !== undefined) this.cause = opts.cause;
  }
}
